import React from 'react'
import { IonIcon } from '@ionic/react'

export const StrokeIcon = (props: { slot?: string }) => {
  return <IonIcon src={'/assets/icons/stroke.svg'} {...props} />
}
export default StrokeIcon
